import { defineComponent as _defineComponent } from 'vue'
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
} from 'echarts/components';
import VChart, { THEME_KEY } from 'vue-echarts';
import { ref, provide, onMounted } from 'vue';
import chartsApi from '@/api/charts';

type tag = {
    tagName: string;
    num: number;
}

type series = {
    name: string;
    value: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'pie',
  setup(__props, { expose: __expose }) {

use([
    CanvasRenderer,
    PieChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
]);

provide(THEME_KEY, 'default');
const chart = ref();

let legendArr = ref<string[]>([]);
let seriesArr = ref<series[]>([]);
const option = ref({
    title: {
        text: '标签数量',
        left: 'center',
    },
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
    },
    legend: {
        orient: 'vertical',
        left: 'left',
        top: 'left',
        data: legendArr,
        // data: ['Direct', 'Email', 'Ad Networks', 'Video Ads', 'Search Engines'],
    },
    series: [
        {
            name: 'Traffic Sources',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            // data: [
            //     { value: 335, name: 'Direct' },
            //     { value: 310, name: 'Email' },
            //     { value: 234, name: 'Ad Networks' },
            //     { value: 135, name: 'Video Ads' },
            //     { value: 1548, name: 'Search Engines' },
            // ],
            data: seriesArr,
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
            },
        },
    ],
});

function resize() {
    chart.value.resize();
}

__expose({ resize });

onMounted(async () => {
    const res = await chartsApi.tag_count(5);
    res.request.map((item: tag) => {
        legendArr.value.push(item.tagName);
        seriesArr.value.push({ name: item.tagName, value: item.num });
    })
    
})

const __returned__ = { chart, get legendArr() { return legendArr }, set legendArr(v) { legendArr = v }, get seriesArr() { return seriesArr }, set seriesArr(v) { seriesArr = v }, option, resize, get VChart() { return VChart } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})